import React, { ReactElement, Component, useState, useEffect, Dispatch, SetStateAction, useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import "../less/service.less";
import {
    http_get,
    format_time,
    loading_alert_before,
    loading_alert_after,
    http_delete,
    alert,
    http_put,
} from '../common-file/service';

// 组建
import BodyTitleCard from '../component/body-title-card';
import TableList from '../component/table';
import Modals from '../component/modal';
import NoPermissionModal from  '../component/no-permission-modal';
import BackupProtocol from '../backup-protocol/backup-protocol';
import { Modal } from "antd";
import {worker_fetch} from "../../../worker/worker-fetch";

// 全局变量
import { ServiceNameContext } from '../contexts/service-name-select';
import { ModalVisibleContext } from '../contexts/modal-visible';
import { ModalDataContext } from '../contexts/modal-data';
import { SubscriptionSelectedContext } from '../contexts/subscription-selected';
import { SearchValueContext } from "../contexts/search-value";
import { TableListDataContext } from '../contexts/table-list-data';
import { ModalLoadingContext } from '../contexts/modal-loading';
import { DatacenternameContext } from "../../../contexts/datacenter-name";
import { IUserInfoType, UserInfoContext } from "../../../contexts/user-info";
import { cry } from "../../../img";
import { subscriptionType, modalType, modalDataType, itemType } from '../common-file/interfaceType';

const columns_1 = ['status', 'instance_name', 'instance_id', 'service_name', 'plan', 'create_time'];
const columns_3 = ['status', 'subscription_name', 'company', 'instance_name', 'instance_id', 'service_name', 'plan', 'create_time'];

const return_columns = (service_name: any, subscriptionId: any) => {
    if ('Shared DB, SharedDB, RabbitMQ'.indexOf(service_name) >= 0) {
        return subscriptionId === 'all' ? columns_3 : columns_1
    } else {
        return subscriptionId === 'all' ? columns_3 : columns_1
    }
};

const AppList: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {

    const { intl, history } = props,
        [datasource, set_datasource]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        [filter_datasource, set_filter_datasource]: [any, Dispatch<SetStateAction<any>>] = useState([]),
        service_name: string = useContext(ServiceNameContext)[0],
        [modal_visible, set_modal_visible]: [modalType, Dispatch<SetStateAction<modalType>>] = useContext(ModalVisibleContext),
        [modal_data, set_modal_data]: [modalDataType, Dispatch<SetStateAction<modalDataType>>] = useContext(ModalDataContext),
        [reload_list, set_reload_list]: [boolean, Dispatch<SetStateAction<any>>] = useState(false),
        subscription_selected: subscriptionType = useContext(SubscriptionSelectedContext)[0],
        user_info: IUserInfoType = useContext(UserInfoContext)[0],
        [columns, set_columns]: [any, Dispatch<SetStateAction<any>>] = useState(() => return_columns(service_name, subscription_selected?.subscriptionId)),
        search_value: any = useContext(SearchValueContext)[0],
        [table_list_data, set_table_list_data]: [any, Dispatch<SetStateAction<any>>] = useContext(TableListDataContext),
        // user_me: any = useContext(UserMeContext)[0],
        datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
        set_modal_loading: Dispatch<SetStateAction<boolean>> = useContext(ModalLoadingContext)[1],
        [nosubscription_modal_visible, set_nosubscription_modal_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);

    useEffect(() => {
        subscription_selected && subscription_selected.subscriptionId && datacenter_name && set_reload_list(true);
    }, [service_name, subscription_selected, datacenter_name]);

    useEffect(() => {
        if (subscription_selected?.subscriptionId) {
            set_nosubscription_modal_visible(false)
        } else if (user_info && user_info.ssoRole !== "globalAdmin" && user_info?.ssoSubscriptions?.length <= 0) {
            setTimeout(() => {
                set_nosubscription_modal_visible(true)
            }, 3000);
        }
        // eslint-disable-next-line
    }, [subscription_selected?.subscriptionId, user_info.ssoRole, user_info?.ssoSubscriptions]);

    useEffect(() => {
        // const subscriptionID: string | undefined = subscription_selected?.subscriptionId ? subscription_selected?.subscriptionId : (cookies.get('service_subscription_id') !== "null" ?  cookies.get('service_subscription_id') : undefined);
        const subscriptionID: string | undefined = subscription_selected?.subscriptionId || undefined;
        if (service_name && reload_list && subscriptionID && datacenter_name) {
            reload_list && set_reload_list(false);
            (async () => {
                set_filter_datasource([]);
                loading_alert_before();
                let instance_list: any;
                // const subscriptionID: string = subscription_selected?.subscriptionId as string;
                if (subscriptionID === 'all') {
                    instance_list = await http_get(`/serviceHub/v2/serviceInstances/all?maxResults=999999&serviceName=${service_name === '-1' ? '' : service_name}&datacenterCode=${datacenter_name}`, props);
                } else {
                    instance_list = await http_get(`/serviceHub/v2/subscriptions/${subscriptionID}/serviceInstances?serviceName=${service_name === '-1' ? '' : service_name}&datacenterCode=${datacenter_name}`, props);
                }
                let context_list: any = table_list_data, list: any = [];
                if (instance_list?.data?.services) {
                    // eslint-disable-next-line
                    instance_list.data.services.map((item: any, key: any) => {
                        const { serviceInstanceId,
                            serviceInstanceName,
                            subscriptionId,
                            transactionId,
                            serviceCategory,
                            userId,
                            serviceName,
                            datacenterCode,
                            servicePlanName,
                            createdAt,
                            dashboardUrl,
                            bindable,
                            subscriptionCompany,
                            subscriptionName,
                            lifecycleStatus,
                            userProvided
                        } = item;
                        lifecycleStatus?.toLowerCase() !== 'none' && list.push({
                            key: key,
                            instanceId: serviceInstanceId,
                            instanceName: serviceInstanceName,
                            subscriptionId: subscriptionId,
                            transactionId: transactionId,
                            serviceCategory: serviceCategory,
                            userId: userId,
                            service: serviceName,
                            datacenterCode: datacenterCode,
                            plan: servicePlanName,
                            status: lifecycleStatus,
                            createTime: format_time(createdAt),
                            dashboard_url: dashboardUrl,
                            bindable: bindable,
                            company: subscriptionCompany,
                            subscriptionName: subscriptionName,
                            user_provided: userProvided
                            // capacity: {
                            //     used: Math.floor(Math.random()*100),
                            //     total: 100
                            // }
                        });
                    });
                }
                set_columns(return_columns(service_name, subscriptionID));
                context_list.service_instance_list = list;
                set_datasource(list);
                set_table_list_data(context_list);
                loading_alert_after();
            })()
        }
        // eslint-disable-next-line
    }, [service_name, reload_list, datacenter_name, subscription_selected?.subscriptionId]);

    // const columns = ['status', 'instance_name', 'instance_id', 'service_name', 'plan', 'create_time'];

    // useEffect(()=>{
    //     set_filter_datasource([]);
    // const {subscriptionId} =subscription_selected;
    // if('Shared DB, SharedDB, RabbitMQ'.indexOf(service_name) >= 0){
    //     set_columns(subscriptionId === 'all'? columns_4: columns_2);
    //     // set_columns(['status', 'instance_name', 'instance_id', 'capacity', 'service_name', 'plan', 'create_time']);
    // }else {
    //     set_columns(subscriptionId === 'all'? columns_3: columns_1);
    //     // set_columns(['status', 'instance_name', 'instance_id', 'service_name', 'plan', 'create_time']);
    // }
    // }, [service_name]);

    useEffect(() => {
        if (modal_visible.toggle) {
            let title: string = '', content = '', type = '', item: any = {};
            switch (modal_visible.type) {
                case 'cancel': title = 'confirm';
                    content = 'sure_to_cancel';
                    type = 'cancel';
                    break;
                case 'create': title = 'subscription_title';
                    type = 'create';
                    user_info.subscription_id === 'all' && (item.subscription_all = true);
                    break;
                case 'rename': title = 'rename_instance';
                    type = 'rename';
                    break;
                default: break;
            }
            title && set_modal_data({
                title: title,
                type: type,
                confirmContent: content,
                datasource: datasource,
                item: item
            })
        }
        // eslint-disable-next-line
    }, [modal_visible, set_modal_data]);

    useEffect(() => {
        if (modal_data.formValue) {
            if (modal_data.type === 'cancel') {
                loading_alert_before();
                (async () => {
                    const cancel_item = JSON.parse(sessionStorage.getItem('instance_list_item_selected') || '{}') as unknown as itemType,
                        { instanceId } = cancel_item,
                        cancel_subscribe = await http_delete(`/serviceHub/v2/serviceInstances/${instanceId}`, null, props);
                    // const cancel_subscribe = await http_delete(`/serviceHub/v2/subscriptions/${subscriptionId}/serviceInstances/${instanceId}`, null, props);
                    if (cancel_subscribe) {
                        alert('success', intl.formatMessage({ id: 'cancel' }), intl.formatMessage({ id: 'cancel_success' }))
                    }
                    set_reload_list(true);
                    loading_alert_after();
                })()
            }
        }
        // eslint-disable-next-line
    }, [modal_data]);

    useEffect(() => {
        if (search_value.instanceList) {
            set_filter_datasource(datasource.filter((item: any) => item.instanceName.toLocaleLowerCase().indexOf(search_value.instanceList.toLocaleLowerCase()) > -1));
        } else {
            set_filter_datasource(datasource);
        }
    }, [search_value, datasource]);

    useEffect(() => {
        if (modal_data.formValue) {
            switch (modal_data.title) {
                case 'subscription_title':
                    (async () => {
                        const {
                            // subscriptionId,
                            authenticationDatabase,
                            bindable,
                            // chargeType,
                            dashboardUrl,
                            // dataService,
                            databaseVersion,
                            externalHosts,
                            internalHosts,
                            location,
                            parameters,
                            password,
                            persistentDiskSize,
                            persistentDiskType,
                            // serviceCategory,
                            serviceInstanceId,
                            // serviceInstanceName,
                            // serviceNameInstance,
                            // servicePlanName,
                            // serviceProperty,
                            // transactionId,
                            // userId,
                            username,
                            vmSize,
                            vmType,
                            ssl,
                        } = modal_data.formValue;
                        const form_data: object = {
                            // subscriptionId: subscriptionId||user_info.subscription_id,
                            serviceInstanceId: serviceInstanceId,
                            // serviceInstanceName: serviceInstanceName,
                            // serviceCategory: serviceCategory || null,
                            // transactionId: transactionId,
                            // userId: userId || null,
                            // serviceName: serviceNameInstance,
                            datacenterCode: datacenter_name,
                            // servicePlanName: servicePlanName,
                            bindable: bindable || 'true',
                            parameters: parameters,
                            dashboardUrl: dashboardUrl || null,
                            // serviceProperty: serviceProperty || null,
                            // chargeType: chargeType || null,
                            // pnInfo: dataService,
                            internalHosts: internalHosts,
                            externalHosts: externalHosts,
                            ssl: ssl === 'true',
                            username: username,
                            password: password,
                            authenticationDatabase: authenticationDatabase || null,
                            deploymentProperties: {
                                location: location || null,
                                databaseVersion: databaseVersion || null,
                                vmType: vmType || null,
                                vmSize: vmSize || null,
                                persistentDiskSize: Number(persistentDiskSize) || null,
                                persistentDiskType: persistentDiskType || null
                            }
                        };
                        loading_alert_before();
                        const create_instance: any = await http_put('/serviceHub/v2/serviceInstances/manual', form_data, props);
                        if (create_instance) {
                            set_reload_list(true);
                            set_modal_visible({ toggle: false });
                            alert('success', intl.formatMessage({ id: modal_data.title }), intl.formatMessage({ id: 'subscription_success' }))
                        } else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'rename_instance':
                    (async () => {
                        loading_alert_before();
                        const { instanceId } = JSON.parse(sessionStorage.getItem('instance_list_item_selected') || '{}'),
                            { serviceInstanceName } = modal_data.formValue,
                            rename_res: any = await http_put(`/serviceHub/v2/serviceInstances/${instanceId}`, { serviceInstanceName: serviceInstanceName }, props);
                        if (rename_res) {
                            set_reload_list(true);
                            set_modal_visible({ toggle: false });
                        } else {
                            set_modal_loading(false)
                        }
                        loading_alert_after();
                    })();
                    break;
                case 'edit_instance':
                    (async () => {
                        loading_alert_before();
                        const {instanceId} = JSON.parse(sessionStorage.getItem('instance_list_item_selected') || '{}'),
                          {
                              authenticationDatabase,
                              ssl,
                              externalHosts,
                              internalHosts,
                              password,
                              username,
                              editInstanceCheckbox,
                              updateSecret
                          } = modal_data.formValue,
                          edit_res: any = await worker_fetch({
                              url: `/serviceHub/v2/userProvided/${instanceId}?restartApp=${!!editInstanceCheckbox}&bindUnbind=${!!updateSecret}`,
                              method: 2,
                              props: {formatMessage: intl.formatMessage, history},
                              datacenter_name,
                              body: {
                                  internalHosts,
                                  externalHosts,
                                  username,
                                  password,
                                  authenticationDatabase,
                                  ssl: ssl === 'true',
                                  parameters: {}
                              }
                          });
                        if (edit_res.status >= 200 && edit_res.status < 300) {
                            set_reload_list(true);
                            set_modal_visible({toggle: false});
                            alert('success', intl?.formatMessage({id: modal_data.title}), intl?.formatMessage({id: 'edit_success'}))
                        } else {
                            set_modal_loading(false);
                            alert('error', edit_res?.data?.reason, edit_res?.data?.message);
                        }
                        loading_alert_after();
                    })();
                    break;
                default: break;
            }
        }
        // eslint-disable-next-line
    }, [modal_data, set_modal_visible]);

    return (
        <div className="px-20 mt-20 service-portal">
            <BodyTitleCard
                card_title={{
                    name: 'instance_list',
                    subscription: 'service_list_subscription',
                    info: [{
                        key: 'total_service',
                        value: datasource?.length
                    }]
                } as any}
                formList={{
                    select: {
                        service: true
                    },
                    input: [{
                        key: 'input',
                        xs: 0,
                        sm: 8,
                        md: 10,
                        lg: 14,
                        xxl: 16
                    }],
                    add: (user_info.ssoRole && ",,globaladmin".indexOf(user_info.ssoRole.toLowerCase()) > 0) || (user_info.role && ",,datacenteradmin".indexOf(user_info.role.toLowerCase()) > 0)
                } as any}
                searchPlaceholder={intl.formatMessage({ id: 'instance_name' })}
            />
            <div>
                <div className="mt-20 no_pointer">
                    <TableList
                        datasource={filter_datasource.length > 0 ? filter_datasource : search_value.instanceList ? [] : table_list_data.service_instance_list}
                        columns={columns}
                        action={{ secret_management: true, backup_restore: true, edit: 'instance' } as any}
                    />
                </div>
            </div>
            <Modals />
            <Modal
                visible={nosubscription_modal_visible}
                width={780}
                footer={null}
                centered={true}
                onCancel={() => set_nosubscription_modal_visible(false)}
                className="norole_modal"
            >
                <div className="no_role_div">
                    <img src={cry} alt="sorry" />
                    <span className="px-20"><FormattedMessage id="sorry_no_subscription_permission" /></span>
                </div>
            </Modal>
            <NoPermissionModal/>
            <BackupProtocol/>
        </div>
    )
};

export default injectIntl(AppList);
